// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"1c0a14de7564e931ac6c","966":"a6b690038fe4b073bb1a"}[chunkId] + ".js";
};